import { RenderDetailViewProps } from 'interfaces/model.interface'

import { ClinicalTrialsData } from 'config/common/baseModel'

import Detail from './Detail'

export const IDAClinicalTrialsDetailView = ({
  model,
  data,
  setSelectedRow,
  viewData,
}: RenderDetailViewProps<Record<ClinicalTrialsData, string>>) => {
  if (!data) {
    return null
  }
  return (
    <Detail
      model={model}
      title='id'
      trial={data}
      handleClose={() => setSelectedRow(null)}
      viewData={viewData}
    />
  )
}
